import LandingPage from "@web/pages/landing/LandingPage";

export default function Index() {
  return <LandingPage />;
}
